import * as THREE from 'three/webgpu';
import { isFeatureFace } from '../../mesh/feature';
import { isDatumPlaneObject } from '../../reference/DatumPlane';

/**
 * 收集测量选中视觉管辖对象 ID 集合。
 *
 * 设计说明：
 * 1. 测量选中外观由 `MeasureSelectionVisualOverlay` 独占，底层 TransitionState 不得覆写；
 * 2. 特征面选中时需同步纳入其边界线，避免 hover 刷新把线框恢复为默认色；
 * 3. 基准面选中时纳入其边框子线，与叠加层覆写范围保持一致。
 *
 * @param selectedObjects 测量选中对象列表。
 * @returns 底层视觉状态刷新时应跳过的对象 ID 集合。
 */
export function collectMeasureSelectionVisualObjectIds(
    selectedObjects: readonly THREE.Object3D[],
): ReadonlySet<string> {
    const objectIds = new Set<string>();

    selectedObjects.forEach((selectedObject) => {
        objectIds.add(selectedObject.uuid);

        if (isFeatureFace(selectedObject)) {
            selectedObject.getBoundaryLines().forEach((boundaryLine) => {
                objectIds.add(boundaryLine.uuid);
            });
            return;
        }

        if (isDatumPlaneObject(selectedObject)) {
            selectedObject.traverse((childObject) => {
                if (childObject instanceof THREE.Line) {
                    objectIds.add(childObject.uuid);
                }
            });
        }
    });

    return objectIds;
}
